var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResistance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#65306A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 44,
    cy: 40,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 21,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 37,
    cy: 43,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.1,12.9C15.2,11,12.7,10,10,10s-5.2,1-7.1,2.9C1,14.8,0,17.3,0,20c0,2.7,1,5.2,2.9,7.1l15.6,15.6l14.1-14.1 L17.1,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.1,3.9C55.2,2,52.7,1,50,1s-5.2,1-7.1,2.9L27.4,19.5l14.1,14.1l15.6-15.6C59,16.2,60,13.7,60,11 S59,5.8,57.1,3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,36c0-2.2-1.8-4-4-4s-4,1.8-4,4s1.8,4,4,4S40,38.2,40,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29,40c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S31.2,40,29,40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39,46c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S41.2,46,39,46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29,51c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S31.2,51,29,51z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResistance);
export default __webpack_public_path__ + "static/media/resistance.e6e566d194114e1b1fd10785c6ba9a45.svg";
export { ForwardRef as ReactComponent };